module.exports = __webpack_public_path__ + "img/halkbank_logo.92c29f52.svg";